import { combineReducers, createReducer } from "@reduxjs/toolkit";

import type { DashboardState, OutageType } from "src/types";
import { setActiveOutageType, setNextWeek, setPreviousWeek, setThisWeek } from "./actions";

const weekOffset = createReducer<number>(0, (builder) =>
    builder
        .addCase(setNextWeek, (state) => state + 1)
        .addCase(setPreviousWeek, (state) => state - 1)
        .addCase(setThisWeek, () => 0),
);

const activeOutageType = createReducer<OutageType | null>(null, (builder) =>
    builder.addCase(setActiveOutageType, (_, action) => action.payload),
);

export const reducer = combineReducers<DashboardState>({
    weekOffset,
    activeOutageType,
});
